import * as _ from 'lodash-es';
import {FloatLayoutDefinition} from '../float-layout';
import {Cell} from './cell';
import {CellDefinition, LayoutDefinition} from './layout-definition';

export class LayoutFactoryBase {

    protected setCellsActiveWidgetsByDef(cells: Cell[], cellDefs: CellDefinition[]): void {
        cells.forEach((cell, iCell) => {
            cell.activeWidget = cell.widgets[cellDefs[iCell].activeWidgetIndex || 0] || null;
        });
    }

    protected orderCellsWidgetsByDef(cells: Cell[], layoutDef: LayoutDefinition | FloatLayoutDefinition): void {
        cells.forEach((cell, iCell) => {
            const cellDef = layoutDef.cells[iCell];
            const widgetIds = cellDef.widgets;

            if (cell.widgets.length > 1) {
                const widgetById = _.keyBy(cell.widgets, widget => widget.id);

                cell.widgets = widgetIds
                    .map(widgetId => widgetById[widgetId])
                    .filter(widget => !!widget); // [COMMON-1254] Exclude unknown widget IDs in case of broken layout.
            }
        });
    }
}
